export const COMPONENT_NAME = "admin-application-bank-requisites";



